import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";
import ArtistCard from "../../components/ArtistCard/ArtistCard";

const MostPopularBands = () => {
  // Tilat bändien datalle ja latauksen statukselle
  const [bands, setBands] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Navigointi bändin profiiliin
  const handleViewProfile = (slug) => {
    navigate(`/esiintyja/${slug}`);
  };

  // API-kutsu bändien hakuun
  const fetchBands = async () => {
    try {
      const response = await fetch("https://spiderlegsproductions.com/api/get_bands.php");
      if (!response.ok) {
        throw new Error(`Bändien haku epäonnistui: ${response.status}`);
      }
      const data = await response.json();
      if (data.success && Array.isArray(data.bands)) {
        setBands(data.bands);
      } else {
        throw new Error("Bändien data ei ole odotetussa muodossa.");
      }
    } catch (error) {
      console.error("Virhe bändien haussa:", error);
      toast.error("Virhe bändien haussa.");
    } finally {
      setLoading(false);
    }
  };

  // Haetaan bändit heti komponentin ladatessa ja alustetaan AOS-animaatiot
  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: true });
    fetchBands();
  }, []);

  // Näytetään latausviesti kunnes API on vastannut
  if (loading) return <p>Ladataan bändit...</p>;

  // Suodatetaan bändit, joilla on premium-jäsenyys JA vähintään yksi arvostelu
  const filteredBands = bands
    .filter(b => b.membership_level === "premium" && Number(b.total_reviews) > 0)
    .slice(0, 6);

  // Jos yksikään premium-bändi ei ole saanut arvosteluja, ei näytetä komponenttia lainkaan
  if (filteredBands.length === 0) return null;

  return (
    <div
      className="container min-h-[620px] flex dark:bg-violet bg-primary dark:bg-opacity-75 bg-opacity-75 rounded-3xl pb-10 p-5"
      data-aos="fade-right"
    >
      <div className="container mx-auto">
        {/* Otsikko ja kuvaus */}
        <div className="flex flex-row items-center flex-wrap">
          <h2 className="text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight text-left font-customFont2 text-darkest dark:text-primary dark:text-shadow-xxl">
            SUOSITUIMMAT ESIINTYJÄT
          </h2>
          <p className="mb-10 font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light">
            Katso asiakkaidemme eniten arvostelemia ja parhaiten arvioituja bändejä ja esiintyjiä! 
            Tältä listalta löydät <strong>viikon esiintyjän</strong>, joka valitaan joka maanantai saamamme palautteen perusteella.
          </p>
        </div>

        {/* Artistikortit */}
        <div className="flex justify-center">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-6 w-full max-w-6xl px-4">
            {filteredBands.map((band) => (
              <ArtistCard
                key={Number(band.id)}
                band={{ ...band, id: Number(band.id) }} // Varmistetaan että id on numero
                onViewProfile={handleViewProfile}
                highlight={Number(band.is_weekly_featured) === 1} // Korostus jos on viikon esiintyjä
              />
            ))}
          </div>
        </div>

        {/* Näytä kaikki esiintyjät -nappi */}
        <div className="grid place-content-center mt-10">
          <Link
            to="/esiintyjat"
            onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "instant" })}
            aria-label="Katso kaikki esiintyjät"
          >
            <ResponsiveButton className="w-72" variant="seemore">
              Katso kaikki!
            </ResponsiveButton>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MostPopularBands;
